export enum DoctorStatusEnum {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}
